/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Players_CountInputs */



/**
* | output |
* | --- |
* | "{count} players" |
*
* @param {Players_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_count = /** @type {((inputs: Players_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueurs`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugadores`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogadores`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatori`)
	return /** @type {LocalizedString} */ (`${i?.count} players`)
});